// English source strings of delegated service grants (decision D41-C4): the chat card and the Kanban facts of a grant
// request, and the Settings panel that lists live grants and revokes them. Merged into `en`; pt-BR lives in pt-BR-grant.ts.
export const enGrant = {
  "grant.title": "Permission for a server action",
  "grant.field.action": "Action",
  "grant.field.resource": "Resource",
  "grant.field.reason": "Agent's reason",
  "grant.field.secret": "Secret",
  "grant.field.effect": "Effect",
  "grant.field.terms": "Duration and limit",
  "grant.field.reversal": "Undo",
  "grant.action.service.restart": "Restart a service",
  "grant.action.service.redeploy": "Deploy commit {commit} again",
  "grant.action.database.provision": "Create a PostgreSQL database named {name}",
  "grant.action.env.set_secret_ref": "Point the variable {key} at a stored secret",
  "grant.operation.service.restart": "Restart a service",
  "grant.operation.service.redeploy": "Redeploy a commit",
  "grant.operation.database.provision": "Create a database",
  "grant.operation.env.set_secret_ref": "Point a variable at a secret",
  "grant.effect.restart": "The service restarts and is unavailable for a few moments.",
  "grant.effect.redeploy": "The application runs this commit instead of the current one.",
  "grant.effect.database_create": "A new database is created in the project environment; existing data does not change.",
  "grant.effect.env_set": "The variable points to the named secret; the secret value never appears in chat.",
  "grant.reversal.restart": "Nothing to undo: the service runs again on its own.",
  "grant.reversal.redeploy_previous": "The previous commit can be deployed again.",
  "grant.reversal.database_manual_delete": "Not automatic: the database must be deleted by hand in Coolify.",
  "grant.reversal.env_restore_previous": "The previous reference of the variable can be restored.",
  "grant.term.once": "This time only: 1 use, valid for 24 hours.",
  "grant.term.mission": "For this task: up to 50 uses, valid for 24 hours.",
  "grant.term.persistent": "Whenever needed: up to 100 uses, reviewed in 30 days.",
  "grant.option.once": "Yes, this time only",
  "grant.option.mission": "Yes, during this task",
  "grant.option.persistent": "Yes, whenever needed",
  "grant.option.deny": "No, deny",
  "grant.choose": "Choose an answer",
  "grant.adminOnly": "Only an organization administrator can decide this request.",
  "grant.decided": "Decision recorded: {option}.",
  "grant.unreadable": "The details of this request could not be read, so it cannot be answered here.",
  "grant.panel.title": "Delegated permissions",
  "grant.panel.intro": "Live permissions that let an agent run one server action. Revoking one stops its next use at once; an action already running is not undone.",
  "grant.panel.empty": "No live permission.",
  "grant.panel.uses": "Uses: {uses} of {max}",
  "grant.panel.expires": "Expires",
  "grant.panel.reviewDue": "Review due",
  "grant.panel.revoke": "Revoke",
  "grant.panel.revokeTitle": "Revoke this permission",
  "grant.panel.revokeBody": "The agent stops using this permission at its next request. An action already running is not undone.",
  "grant.panel.reason": "Reason for revoking",
  "grant.panel.reasonHint": "Required. It is kept in the audit log.",
  "grant.panel.confirmRevoke": "Revoke permission",
  "grant.panel.revoked": "Permission revoked.",
  "grant.kind.once": "This time only",
  "grant.kind.mission": "During a task",
  "grant.kind.persistent": "Whenever needed",
} as const;
